module.exports = __webpack_public_path__ + "43ecffaca3ea616f725fcb9e1a8cccc8.jpg";